<!-- payku-modal.component.html -->
<div class="payku-modal" role="dialog" aria-modal="true" aria-labelledby="title-payku" aria-describedby="desc-payku">
	<div class="modal-header">
		<div class="header-content">
			<h5 id="title-payku" class="modal-title">
				<i class="fa-solid fa-credit-card me-2 text-primary" aria-hidden="true"></i>
				Crear Cuenta Payku
			</h5>
			<p id="desc-payku" class="modal-subtitle">Configura tu cuenta para recibir pagos de forma segura</p>
		</div>

		<button type="button" class="payku-close-btn" aria-label="Cerrar" (click)="activeModal.dismiss()">
			<i class="fa-solid fa-xmark" aria-hidden="true"></i>
		</button>
	</div>

	<form [formGroup]="form" (ngSubmit)="submit()" novalidate>
		<div class="modal-body">
			<section class="section-block" aria-labelledby="sec-personal" id="section-personal">
				<h6 id="sec-personal" class="section-title">
					<i class="fa-solid fa-user me-2" aria-hidden="true"></i>
					Información Personal
				</h6>

				<div class="row g-3">
					<!-- Email -->
					<div class="col-12 col-md-6">
						<label for="inp-email" class="form-label required">Email</label>
						<div class="input-group" [ngClass]="{ 'is-invalid': f.email.touched && f.email.invalid }">
							<span class="input-group-text">
								<i class="fa-solid fa-envelope text-muted" aria-hidden="true"></i>
							</span>
							<input id="inp-email" type="email" inputmode="email" autocomplete="email"
								formControlName="email" class="form-control" placeholder="ejemplo@correo.com"
								[attr.aria-invalid]="f.email.invalid ? 'true' : 'false'" [attr.aria-required]="true" />
						</div>
						<div *ngIf="f.email.touched && f.email.invalid" class="invalid-feedback" aria-live="polite">
							<span *ngIf="f.email.errors?.required">El email es requerido.</span>
							<span *ngIf="f.email.errors?.email">Ingresa un email válido.</span>
						</div>
					</div>

					<!-- Nombre -->
					<div class="col-12 col-md-6">
						<label for="inp-name" class="form-label required">Nombre Completo</label>
						<div class="input-group" [ngClass]="{ 'is-invalid': f.name.touched && f.name.invalid }">
							<span class="input-group-text">
								<i class="fa-solid fa-user text-muted" aria-hidden="true"></i>
							</span>
							<input id="inp-name" type="text" autocomplete="name" formControlName="name"
								class="form-control" placeholder="Ingresa tu nombre completo"
								[attr.aria-invalid]="f.name.invalid ? 'true' : 'false'" [attr.aria-required]="true" />
						</div>
						<div *ngIf="f.name.touched && f.name.invalid" class="invalid-feedback" aria-live="polite">El
							nombre completo
							es requerido.</div>
					</div>

					<!-- Teléfono -->
					<div class="col-12 col-md-6">
						<label for="inp-phone" class="form-label required">Teléfono</label>
						<div class="input-group" [ngClass]="{ 'is-invalid': f.phone.touched && f.phone.invalid }">
							<span class="input-group-text">
								<i class="fa-solid fa-phone text-muted" aria-hidden="true"></i>
							</span>
							<input id="inp-phone" type="tel" inputmode="tel" autocomplete="tel-national"
								formControlName="phone" class="form-control" placeholder="9 1234 5678" maxlength="12"
								[attr.aria-invalid]="f.phone.invalid ? 'true' : 'false'" [attr.aria-required]="true" />
						</div>
						<div *ngIf="f.phone.touched && f.phone.invalid" class="invalid-feedback" aria-live="polite">
							<span *ngIf="f.phone.errors?.required">El teléfono es requerido.</span>
							<span *ngIf="f.phone.errors?.pattern">Debe tener entre 9 y 12 dígitos.</span>
						</div>
					</div>
				</div>
			</section>
			<section class="section-block" aria-labelledby="sec-bank" id="section-bancaria">
				<h6 id="sec-bank" class="section-title">
					<i class="fa-solid fa-building-columns me-2" aria-hidden="true"></i>
					Información Bancaria
				</h6>

				<!-- Toggle usar datos anteriores -->
				<div class="toggle-prev mb-3" *ngIf="datosBancarios?.length">
					<div class="form-check form-switch">
						<input class="form-check-input" type="checkbox" id="usarDatosAnteriores"
							[(ngModel)]="usarDatosAnteriores" [ngModelOptions]="{ standalone: true }"
							(change)="toggleUsarDatosAnteriores()" aria-describedby="hint-prev" />
						<label class="form-check-label" for="usarDatosAnteriores"> Usar datos bancarios anteriormente
							ingresados
						</label>
					</div>
					<small id="hint-prev" class="form-text text-muted"> Puedes seleccionar una cuenta guardada o
						ingresar una
						nueva. </small>
				</div>

				<!-- Selector de cuenta anterior -->
				<div class="mb-3" *ngIf="usarDatosAnteriores">
					<label for="sel-prev" class="form-label required">Seleccionar cuenta bancaria</label>
					<div class="input-group"
						[ngClass]="{ 'is-invalid': f.cuentaBancariaAnterior?.touched && f.cuentaBancariaAnterior?.invalid }">
						<span class="input-group-text">
							<i class="fa-solid fa-clock-rotate-left text-muted" aria-hidden="true"></i>
						</span>
						<select id="sel-prev" class="form-control" formControlName="cuentaBancariaAnterior">
							<option value="">Selecciona una cuenta...</option>
							<option *ngFor="let cuenta of datosBancarios" [value]="cuenta.cuentaBancariaId">
								{{ getCuentaDisplayText(cuenta) }}
							</option>
						</select>
					</div>
					<div *ngIf="f.cuentaBancariaAnterior?.touched && f.cuentaBancariaAnterior?.invalid"
						class="invalid-feedback" aria-live="polite">Debes seleccionar una cuenta bancaria.</div>
				</div>

				<!-- Datos bancarios nuevos -->
				<ng-container *ngIf="!usarDatosAnteriores">
					<div class="row g-3">
						<!-- RUT -->
						<div class="col-12 col-md-6">
							<label for="inp-rut" class="form-label required">RUT</label>
							<div class="input-group" [ngClass]="{ 'is-invalid': f.rut.touched && f.rut.invalid }">
								<span class="input-group-text">
									<i class="fa-solid fa-id-card text-muted" aria-hidden="true"></i>
								</span>
								<input id="inp-rut" type="text" maxlength="12" formControlName="rut"
									class="form-control" placeholder="12.345.678-9"
									[attr.aria-invalid]="f.rut.invalid ? 'true' : 'false'"
									[attr.aria-required]="true" />
							</div>
							<div *ngIf="f.rut.touched && f.rut.invalid" class="invalid-feedback" aria-live="polite">
								<span *ngIf="f.rut.errors?.required">El RUT es requerido.</span>
								<span *ngIf="f.rut.errors?.rutInvalido">Ingresa un RUT válido.</span>
							</div>
						</div>

						<!-- Banco -->
						<div class="col-12 col-md-6">
							<label for="sel-bank" class="form-label required">Banco</label>
							<div class="input-group" [ngClass]="{ 'is-invalid': f.sbif.touched && f.sbif.invalid }">
								<span class="input-group-text">
									<i class="fa-solid fa-building-columns text-muted" aria-hidden="true"></i>
								</span>
								<select id="sel-bank" formControlName="sbif" class="form-control">
									<option value="" disabled>Selecciona tu banco...</option>
									<option *ngFor="let b of bancos" [value]="b.sbif">{{ b.nombre }}</option>
								</select>
							</div>
							<div *ngIf="f.sbif.touched && f.sbif.invalid" class="invalid-feedback" aria-live="polite">
								Selecciona un
								banco.</div>
						</div>

						<!-- Tipo de cuenta -->
						<div class="col-12 col-md-6">
							<label for="sel-type" class="form-label required">Tipo de cuenta</label>
							<div class="input-group" [ngClass]="{ 'is-invalid': f.type.touched && f.type.invalid }">
								<span class="input-group-text">
									<i class="fa-solid fa-wallet text-muted" aria-hidden="true"></i>
								</span>
								<select id="sel-type" formControlName="type" class="form-control">
									<option value="" disabled>Selecciona el tipo...</option>
									<option *ngFor="let t of accountTypes" [value]="t.id">{{ t.label }}</option>
								</select>
							</div>
							<div *ngIf="f.type.touched && f.type.invalid" class="invalid-feedback" aria-live="polite">
								Selecciona el
								tipo de cuenta.</div>
						</div>

						<!-- Número de cuenta -->
						<div class="col-12 col-md-6">
							<label for="inp-num" class="form-label required">Número de cuenta</label>
							<div class="input-group" [ngClass]="{ 'is-invalid': f.num.touched && f.num.invalid }">
								<span class="input-group-text">
									<i class="fa-solid fa-hashtag text-muted" aria-hidden="true"></i>
								</span>
								<input id="inp-num" type="text" maxlength="40" formControlName="num"
									class="form-control" placeholder="Ingresa el número de cuenta"
									[attr.aria-invalid]="f.num.invalid ? 'true' : 'false'"
									[attr.aria-required]="true" />
							</div>
							<div *ngIf="f.num.touched && f.num.invalid" class="invalid-feedback" aria-live="polite">
								<span *ngIf="f.num.errors?.required">El número de cuenta es requerido.</span>
								<span *ngIf="f.num.errors?.pattern">Debe tener mínimo 6 dígitos.</span>
							</div>
						</div>
					</div>
				</ng-container>
			</section>

			<!-- Info -->
			<aside class="info-box mt-4" aria-live="polite">
				<div class="info-icon" aria-hidden="true">
					<i class="fa-solid fa-circle-info"></i>
				</div>
				<div class="info-content">
					<h6>Información importante</h6>
					<p class="mb-0">Tu cuenta Payku se creará con estos datos bancarios. Aquí es donde te realizarán la
						transferencia.</p>
				</div>
			</aside>

			<!-- Términos -->
			<div class="terms-section mt-3">
				<section id="section-terminos">
					<div class="form-check">
						<input class="form-check-input" type="checkbox" formControlName="terms" id="chkTerms" />
						<label class="form-check-label" for="chkTerms">
							Acepto los
							<a href="https://payku.cl/legal/legal/" target="_blank" class="terms-link">Términos y
								Condiciones</a>
						</label>
					</div>
					<div class="form-check mt-2">
						<input class="form-check-input" type="checkbox" formControlName="termsAlianza"
							id="chkTermsAlianza" />
						<label class="form-check-label" for="chkTermsAlianza">
							Acepto los
							<button type="button" class="btn btn-link p-0 align-baseline terms-link"
								(click)="downloadTermsPdf()">Términos de la Alianza Payku - SimpleFactura</button>
						</label>
					</div>
				</section>
				<div *ngIf="(f.terms.touched && f.terms.invalid) || (f.termsAlianza.touched && f.termsAlianza.invalid)"
					class="invalid-feedback d-block">
					<div *ngIf="f.terms.touched && f.terms.invalid">Debes aceptar los términos y condiciones de Payku.
					</div>
					<div *ngIf="f.termsAlianza.touched && f.termsAlianza.invalid">Debes aceptar los términos de la
						alianza Payku -
						SimpleFactura.</div>
				</div>
			</div>
		</div>

		<div class="modal-footer">
			<div class="security-badge">
				<i class="fa-solid fa-shield-halved me-1 text-success" aria-hidden="true"></i>
				<small>Conexión segura SSL</small>
			</div>

			<div class="btn-group">
				<button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">
					<i class="fa-solid fa-xmark me-1" aria-hidden="true"></i>
					Cancelar
				</button>

				<button type="submit" class="btn btn-payku" [disabled]="form.invalid">
					<i class="fa-solid fa-plus me-1" aria-hidden="true"></i>
					Crear cuenta
				</button>
			</div>
		</div>
	</form>
</div>